import { AlgoDescriptionBuilderBase } from '../algo-description-builder-base.class';
import { StrategyParameters } from '../../strategies/strategy-parameters.enum';

export class FreezeHedgeAlgoDescriptionBuilder extends AlgoDescriptionBuilderBase {
   getSymbolPropertyNames(): string[] {
      return ['symbol'];
   }

   getAlgoName(parameters: StrategyParameters): string {
      return 'Freeze';
   }

   getDescription(parameters: StrategyParameters): string {
      let res = '';
      
      const defaultValue = 'N/A';
      
      let symbol: string = parameters.symbol || defaultValue;

      if (symbol !== defaultValue) {
         symbol = this.DisplayNameService.getDisplayNameForTicker(symbol);
      }

      res += `[${symbol}] `;
      res += `Order Type: ${parameters.ordertype}, `;
      
      if (parameters.customBeta) {
         res += 'Custom Beta: ' + parameters.customBeta;
      }
      
      return res;

   }
}
